import axios, {type AxiosResponse} from 'axios';
import {type ActionTree} from 'vuex';
import TopMessageHandler from '../../../../../library/topMessageHandler';

const actions: ActionTree<EnrolmentPipelineState, RootState> = {
    fetchPipeline({commit, dispatch}, options?): Promise<any>
    {
        commit('update', {loading: true});

        let url = '/employee/enrolment/index/fetch-pipeline';

        options = options || {};

        if (options.params)
        {
            for (let key in options.params)
            {
                if (options.params.hasOwnProperty(key))
                {
                    url += '/' + key + '/' + options.params[key];
                }
            }
        }

        let load = ({data: {data}}: AxiosResponse) =>
        {
            commit('update', {
                loading: false,
                phases: data.phases,
                enrolments: data.enrolments,
                errorMailboxes: data.errorMailboxes,
            });
        };

        let error = () =>
        {
            TopMessageHandler.error('Die Pipeline konnte nicht geladen werden.');
        };

        if (options.axios)
        {
            return axios.get(url).then(load).catch(error);
        }

        return dispatch('getPage', {url: url}, {root: true}).then(load).catch(error);
    },
    updatePipelineStore({commit}, data): void
    {
        commit('update', data);
    },
};

export default actions;